import * as React from 'react';
import { ArrowDownRegular, ArrowUpRegular, DismissRegular } from '@fluentui/react-icons';
export const defaultNavigationIcons = {
    dismiss: /*#__PURE__*/ React.createElement(DismissRegular, null),
    downNavigation: /*#__PURE__*/ React.createElement(ArrowDownRegular, null),
    upNavigation: /*#__PURE__*/ React.createElement(ArrowUpRegular, null)
};
